<template>
    <div class="about-panel">
        <h1>Contribute</h1>
        <p>
            <strong>Source code</strong> : this edition on
            <a
                href="https://github.com/lionel-panhaleux/succubus-club/tree/zero-vtes-engine"
                target="_blank"
            >
                GitHub
            </a>
            , forked from
            <a
                href="https://github.com/thomasWajs/succubus-club/"
                target="_blank"
            >
                Succubus Club
            </a>
            .
        </p>

        <p>
            <strong>Bug reports</strong> :
            <a
                href="https://github.com/lionel-panhaleux/succubus-club/issues/"
                target="_blank"
            >
                GitHub issues
            </a>
        </p>

        <p>
            <strong>Feature requests</strong> : the same
            <a
                href="https://github.com/lionel-panhaleux/succubus-club/issues/"
                target="_blank"
            >
                GitHub issues
            </a>
        </p>

        <h1>Donations</h1>

        <p>
            If you're enjoying your VTES experience here, you can donate to support the ongoing
            development of the Succubus Club.
        </p>

        <p>
            Donations directly contribute to server maintenance, bug fixes, feature development, and
            keeping this free platform available for all players.
        </p>

        <p>
            Github Sponsor ( lowest fees ):&nbsp;<a
                href="https://github.com/sponsors/thomasWajs"
                target="_blank"
                >github.com/sponsors/thomasWajs</a
            ><br />
            Patreon:&nbsp;<a
                href="https://patreon.com/thomasWajs"
                target="_blank"
                >patreon.com/thomasWajs</a
            ><br />

            Paypal:&nbsp;
            <a
                href="https://paypal.me/thomasWajs"
                target="_blank"
                >paypal.com/paypalme/thomasWajs</a
            >
        </p>

        <h1>Backers</h1>
        <p>
            An immense thanks to the amazing people who have financially supported this project.
            Your support is the blood that keeps this project alive!
        </p>
        <ul class="blood-list">
            <li>Juan Carlos Eruntalon</li>
            <li>tryptych</li>
            <li>Diego Farras</li>
        </ul>

        <h1>Testers</h1>
        <p>
            ✨ A vibrant shout out to my friends and first testers :
            <strong>Braf & Shaz</strong> ✨
        </p>

        <p>
            And a very special thanks to the crash-test team, who endured the pain of the buggy beta
            :
        </p>
        <ul class="blood-list">
            <li>Doman</li>
            <li>Jim</li>
            <li>Kuli</li>
            <li>Ramirez</li>
        </ul>
    </div>
</template>
<script setup lang="ts"></script>
